import { EMPTY_PART } from "../hub-table.constants";
import { useHubTableContext } from "../hub-table.context";
import type { HubTableSlotProps } from "../types-hub-table";

/** Conteúdo do estado vazio (padrão: `ListEmptyState`). O Root decide quando mostrar; fora dele, erro. */
export function HubTableEmpty({ children }: HubTableSlotProps) {
  useHubTableContext();
  return <>{children}</>;
}
HubTableEmpty.displayName = EMPTY_PART;
